import type { KeyboardShortcut } from './../ricos-types';
import { createShortcut } from './../ricos-types';

const command: KeyboardShortcut['command'] = ({ event }) => {
  event?.preventDefault();
};

export const blocksMenuShortcuts: KeyboardShortcut[] = [
  createShortcut({
    name: 'OpenBlocksMenu',
    description: 'ShortcutsSheet_BlocksMenu_OpenBlocksMenu',
    group: 'ShortcutsSheet_Section_BlocksMenu',
    keys: {
      macOs: 'Meta+Shift+P',
      windows: 'Ctrl+Shift+P',
    },
    enabled: false,
    command,
  }),
  createShortcut({
    name: 'SelectNextBlockWithTab',
    description: 'ShortcutsSheet_BlocksMenu_SelectTheNextBlock',
    group: 'ShortcutsSheet_Section_BlocksMenu',
    keys: {
      macOs: 'Tab',
      windows: 'Tab',
    },
    enabled: false,
    command,
  }),
  createShortcut({
    name: 'SelectNextBlockArrows',
    description: 'ShortcutsSheet_BlocksMenu_SelectTheNextBlock',
    group: 'ShortcutsSheet_Section_BlocksMenu',
    keys: {
      macOs: 'Arrow',
      windows: 'Arrow',
    },
    enabled: false,
    command,
  }),
  createShortcut({
    name: 'ApplySelection',
    description: 'ShortcutsSheet_BlocksMenu_ApplyASelection',
    group: 'ShortcutsSheet_Section_BlocksMenu',
    keys: {
      macOs: 'Enter',
      windows: 'Enter',
    },
    enabled: false,
    command,
  }),
  createShortcut({
    name: 'ExitBlocksMenu',
    description: 'ShortcutsSheet_BlocksMenu_ExitBlocksMenu',
    group: 'ShortcutsSheet_Section_BlocksMenu',
    keys: {
      macOs: 'Escape',
      windows: 'Escape',
    },
    enabled: false,
    command,
  }),
];
